// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status-pill[data-v-d1e7d0f4]{box-sizing:border-box;height:-moz-max-content;height:max-content;padding:.125rem .5rem;border-radius:.25rem;margin-right:.5rem!important;cursor:pointer;color:#fff;font-size:.875rem;font-weight:400;line-height:1.25rem}.status-pill.opted-in[data-v-d1e7d0f4]{background-color:#008906}.status-pill.opted-out[data-v-d1e7d0f4]{background-color:#d93b3d}", ""]);
// Exports
module.exports = exports;
